var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFooter = void 0;
var TableFooter_1 = __importDefault(require("./TableFooter"));
exports.TableFooter = TableFooter_1.default;
exports.default = TableFooter_1.default;
//# sourceMappingURL=index.js.map